import { MOBILE_SCREEN_SIZE } from "@brandclub/common-ui";
import { InputAdornment, useMediaQuery, useTheme } from "@mui/material";
import StoreInput from "../../StoreComponents/StoreInput";

export const CheckoutInputV2 = (
  props: React.ComponentProps<typeof StoreInput> & {
    endButton?: React.ReactNode;
  }
) => {
  const theme = useTheme();
  const { endButton, inputStyle, ...restProps } = props;
  const mobileView = useMediaQuery(`(max-width:${MOBILE_SCREEN_SIZE}px)`);
  const inputBottomBorder = mobileView
    ? { borderBottom: "1px solid #E0E0E0" }
    : {};

  // Add end adornment if endButton is provided
  const inputProps = endButton
    ? {
        ...restProps.InputProps,
        endAdornment: (
          <InputAdornment position="end">{endButton}</InputAdornment>
        ),
      }
    : restProps.InputProps;

  return (
    <StoreInput
      inputProps={{
        sx: {
          // border: "none",
        },
      }}
      inputStyle={{
        width: "100%",
        maxWidth: "100%",
        minWidth: 200,
        fontSize: "14px",
        fontWeight: 500,
        color: theme.palette.primary.main,
        ...inputBottomBorder,
        ...inputStyle,
      }}
      {...restProps}
      InputProps={inputProps}
      variant={mobileView ? "standard" : "filled"}
      textFieldStyle={{ maxWidth: "100%" }}
    />
  );
};
